import { Component, PropsWithChildren } from 'react';

import { EvtKeys } from 'app/types';

// Local Typings
interface KeyCodeAction {
  action: (evt: KeyboardEvent) => void;
  ctrlKey?: boolean;
  key: EvtKeys;
  metaKey?: boolean;
  shiftKey?: boolean;
}
interface Props {
  disabled?: boolean;
  keyCodeActions: KeyCodeAction[];
}

// Component Definition
class KeyCodeListener extends Component<PropsWithChildren<Props>> {
  componentDidMount() {
    document.addEventListener(
      'keydown',
      this.handleKeyDown,
      false,
    );
  }

  componentWillUnmount() {
    document.removeEventListener(
      'keydown',
      this.handleKeyDown,
      false,
    );
  }

  handleKeyDown = (evt: KeyboardEvent) => {
    const keyCodeAction = this.props.keyCodeActions.find(kca => {
      const {
        ctrlKey = false,
        key,
        metaKey = false,
        shiftKey = false,
      } = kca;

      const keyMatch = key === evt.key as EvtKeys;

      const ctrlMatch = ctrlKey === evt.ctrlKey;
      const metaMatch = metaKey === evt.metaKey;
      const shiftMatch = shiftKey === evt.shiftKey;

      return [keyMatch, ctrlMatch, metaMatch, shiftMatch].every(Boolean);
    });

    if (keyCodeAction && !this.props.disabled) {
      keyCodeAction.action(evt);
    }
  };

  render() {
    return this.props.children;
  }
}

export default KeyCodeListener;
